import DocumentList from '../../Component/ReusableCode/reUsableDocument'
import { IMAGE_BASE_PATH_DBRAIMT } from '../../Config/Config'
import AcademicCalendarData from '../../Assets/JSON/Academics/Academics.json'

const AcademicCalendar = () => {
  return (
    <div>
      <DocumentList
        data={AcademicCalendarData}
        title="Academic Calendar"
        basePath={IMAGE_BASE_PATH_DBRAIMT}
        navigatePath="/academic_calendar"
      />
    </div>
  )
}

export default AcademicCalendar
